import { useState } from 'react';
import { TwoFactorVerification } from '../../components/auth/TwoFactorVerification';
import { TwoFactorSetup } from '../../components/auth/TwoFactorSetup';

export default function TwoFactorTest() {
  const [currentView, setCurrentView] = useState<'menu' | 'verification' | 'setup'>('menu');

  const handleVerifyCode = async (code: string): Promise<boolean> => {
    console.log('Verifying code:', code);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    return Math.random() > 0.5; // Random success/failure for testing
  };

  const handleActivate = async (code: string): Promise<boolean> => {
    console.log('Activating with code:', code);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    return true;
  };

  const handleCancel = () => {
    setCurrentView('menu');
  };

  if (currentView === 'verification') {
    return (
      <TwoFactorVerification
        onVerify={handleVerifyCode}
        onCancel={handleCancel}
        error={null}
      />
    );
  }

  if (currentView === 'setup') {
    return (
      <TwoFactorSetup
        qrCodeUrl="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=otpauth://totp/LogisHaus%3Atest@example.com?secret=JBSWY3DPEHPK3PXP&issuer=LogisHaus"
        secretKey="JBSWY3DPEHPK3PXP"
        onActivate={handleActivate}
        onCancel={handleCancel}
        error={null}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-8">2FA Component Test</h1>
        
        <div className="space-y-4">
          <button
            onClick={() => setCurrentView('verification')}
            className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg hover:bg-blue-600 transition-colors"
          >
            Test Verification Screen (Design 1)
          </button>
          
          <button
            onClick={() => setCurrentView('setup')}
            className="w-full bg-green-500 text-white py-3 px-4 rounded-lg hover:bg-green-600 transition-colors"
          >
            Test Setup Screen (Design 2)
          </button>
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            This page allows you to test both 2FA designs independently
          </p>
        </div>
      </div>
    </div>
  );
}
